import plusIconSource from "@/assets/img/plus-icon-thin-light.svg";
import { BButton, IBFormInputEvents } from "@/lib/typed-bootstrap";
import { upperCaseFirstLetter } from "@/utils";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import * as tsx from "vue-tsx-support";
import FormGroupWithLabel from "../forms/inputs/FormGroupWithLabel.component";
import FormInput from "../forms/inputs/FormInput.component";
import { FormInputWithAction } from "../forms/inputs/FormInputWithAction.component";
import style from "./DataEntryFormParentInput.component.module.scss";
@Component
export class DataEntryFormParentInput extends Vue {
  _tsx!: tsx.DeclareProps<
    Pick<
      DataEntryFormParentInput,
      | "value"
      | "label"
      | "id"
      | "labelAmendment"
      | "inputType"
      | "placeholderText"
      | "buttonDisabled"
      | "shouldValidate"
    >
  > &
    tsx.DeclareOnEvents<
      {
        onParentClick: void;
      } & IBFormInputEvents
    >;

  @Prop({ required: true }) value: string;
  @Prop({ required: true }) label: string;
  @Prop({ required: true }) id: string;
  @Prop({ required: true }) labelAmendment: string;
  @Prop({ required: true }) inputType: string;
  @Prop({ required: true }) placeholderText: string;
  @Prop({ default: false }) buttonDisabled: boolean;
  @Prop({ default: false }) shouldValidate: boolean;

  @Emit("parentClick")
  handleParentClick() {}

  render() {
    const {
      label,
      value,
      id,
      inputType,
      labelAmendment,
      placeholderText,
      buttonDisabled,
      shouldValidate,
    } = this;

    return (
      <FormGroupWithLabel
        label={label}
        labelAmendment={labelAmendment}
        id={id}
        inputType={inputType}
        upperCaseLabel={false}
      >
        <FormInputWithAction
          scopedSlots={{
            action: (className) => (
              <BButton
                onClick={this.handleParentClick}
                class={className}
                disabled={buttonDisabled}
                data-testid={`formInput${upperCaseFirstLetter(id)}-parent`}
              >
                <div class={style.linkIcon}>
                  <img src={plusIconSource} alt="Parent object link" />
                </div>
              </BButton>
            ),
            input: (className) => (
              <FormInput
                id={id}
                on={this.$listeners}
                value={value}
                placeholderText={placeholderText}
                class={className}
                inputType={inputType}
                shouldValidate={shouldValidate}
              />
            ),
          }}
        ></FormInputWithAction>
      </FormGroupWithLabel>
    );
  }
}
